export default __webpack_public_path__ + "static/media/white-noise.c83319cf.gif";